<div class="footer">
  <mat-divider></mat-divider>
  <p>(c) 2021 Eugen, {{ "lbl-all-rights" | translate }} {{ version }}</p>
</div>
